angular.module('bmsApp.trugreen.schedule')
	.controller('TGInventoryRequiredModalCtrl', function ($scope,
														  $modalInstance,
														  $q,
														  $ngBootbox,
														  TGScheduleSvc,
														  EmployeeSvc,
														  TGVisitSvc,
														  ConfigService,
														  $window,
														  date,
														  employeeId) {


		function init() {
			// load inventory for date
			var params = {
				date: date.format('YYYY-MM-DD')
			};
			if(employeeId !== ''){
				params.employeeId = employeeId;
			}
			TGScheduleSvc.inventoryRequired(params)
				.then(function (response) {
					self.visits = response.data.visit_collection;
					self.summary = response.data.summary;
					self.loading = false;
				});

		}

		function print() {
			$window.open('trugreen/inventory-form/' + date.format('YYYY-MM-DD') + '/' + employeeId);
		}

		function cancel() {
			$modalInstance.dismiss('cancel');
		}

		var self = $scope.TGInventoryRequiredCtrl = {
			loading: true,
			processing: false,
			visits: [],
			methods: {
				init: init,
				cancel: cancel,
				print: print
			}
		};


	});
